import moment from 'moment';
import formatCycleRuntime from '../lib/formatter/formatCycleRuntime';

const formatterMixin = {
  methods: {
    isDollar(evt) {
      const event = evt || window.event;
      if (event.target && event.target.value
        && event.target.value.includes('.') && event.target.value.split('.')[1].length >= 2) {
        event.preventDefault();
        return false;
      }
      const charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault();
      } else {
        return true;
      }
      return false;
    },
    numberLocaleEn(v) {
      if (!v) {
        return '--';
      }
      return v.toLocaleString('en');
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      } else {
        return true;
      }
      return false;
    },
    isPhoneNumber(evt) {
      const event = evt || window.event;
      const charCode = (event.which) ? event.which : event.keyCode;
      if (((charCode > 31
        && (charCode < 48 || charCode > 57))
        && charCode !== 46)
        || event.target.value.length > 11) {
        event.preventDefault();
      } else {
        return true;
      }
      return false;
    },
    systemAge(s) {
      if (s) {
        return `${s} year${s > 1 || s === 0 ? 's' : ''}`;
      }
      return '--';
    },
    customDateFilter(date, format) {
      if (date) {
        return moment(date).format(`${format}`);
      }
      return '--';
    },
    customDateFilterMoment(date, format) {
      if (date) {
        return moment(date).format(`${format} | h:mm A`);
      }
      return '--';
    },
    customFullDateAndTime(date, format) {
      if (date) {
        if (format === 'M/D') {
          return `${moment(date).format('dddd, MMM DD, YYYY')} at ${moment(date).format('h:mma')}`;
        }
        return `${moment(date).format('dddd, DD MMM, YYYY')} at ${moment(date).format('h:mma')}`;
      }
      return '--';
    },
    getText(value, type) {
      if (!value) {
        return '--';
      }
      if (type && (type.includes('Supply Air') || type.includes('Delta T'))) {
        return `${Math.round(value)}°`;
      }
      if (type && type.includes('Runtime')) {
        const vInSeconds = Math.abs(value * 3600);
        return formatCycleRuntime(vInSeconds);
      }
      if (type && type === 'water') {
        if (value.type.includes('Water') && value.location) {
          return `${value.location} - ${value.type}`;
        }
        return `${value.systemName} - ${value.type}`;
      }
      return value;
    },
    getDateV2(value) {
      if (value) {
        return moment(value).format('M/D/YY');
      }
      return '--';
    },
    getFullYear(value) {
      if (value) {
        return moment(value).format('MMM Do, YYYY');
      }
      return '--';
    },
    getFullDateAndTimeV2(value) {
      if (value) {
        return `${moment(value).format('M/D/YY')} at ${moment(value).format('h:mma')}`;
      }
      return '--';
    },
    getAmount(v) {
      if (!v) {
        return '--';
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter.format(v);
    },
    getNumberLocale(v) {
      if (v) {
        const digits = v % 1 !== 0 ? 2 : 0;
        return v.toLocaleString('en', {
          minimumFractionDigits: digits,
        });
      }
      return v;
    },
    formatExternalStatus(str) {
      if (!str) {
        return null;
      }
      return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (match) => match.toUpperCase());
    },
  },
};

export default formatterMixin;
